import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ComposableBankingRoutingModule} from './composable-banking-routing.module';
import {ComposableBankingComponent} from './composable-banking.component';
import {BreadcrumbModule} from '../../../components/breadcrumb/breadcrumb.module';
import {SharedModule} from '../../../shared/shared.module';
import {VerticalMenuModule} from '../../../components/vertical-menu/vertical-menu.module';
import {NewLineOfBusinessModule} from '../../../components/new-line-of-business/new-line-of-business.module';
import {IconsModule} from "../../../icons/icons.module";

@NgModule({
  declarations: [
    ComposableBankingComponent
  ],
  imports: [
    CommonModule,
    ComposableBankingRoutingModule,
    BreadcrumbModule,
    SharedModule,
    VerticalMenuModule,
    NewLineOfBusinessModule,
    IconsModule
  ]
})
export class ComposableBankingModule { }
